import { createSelector } from '@reduxjs/toolkit'
import { createAllEntitiesSelector, createEntityGetterSelector } from './entitySelectors'
import { EntityStatus, EntityType, Market, MarketStatus, TradingStatus } from 'api'
import { createAuthorisedUserSelector } from './connectionSelectors'

export function createMarketClosedSelector(market: Market) {
  return createSelector(createAllEntitiesSelector(EntityType.PLATFORM), platforms => {
    if (platforms.length === 0) {
      return false
    } else if (platforms.length !== 1) {
      throw new Error('Found multiple platform entries')
    } else {
      return platforms[0].marketDetails[market]?.marketStatus === MarketStatus.MARKET_CLOSED
    }
  })
}

export function createMarketPreOpenSelector(market: Market) {
  return createSelector(createAllEntitiesSelector(EntityType.PLATFORM), platforms => {
    if (platforms.length === 0) {
      return false
    } else if (platforms.length !== 1) {
      throw new Error('Found multiple platform entries')
    } else {
      return platforms[0].marketDetails[market]?.marketStatus === MarketStatus.MARKET_PRE_OPEN
    }
  })
}

export function createPlatformSuspendedSelector(market: Market) {
  return createSelector(createAllEntitiesSelector(EntityType.PLATFORM), platforms => {
    if (platforms.length === 0) {
      return false
    } else if (platforms.length !== 1) {
      throw new Error('Found multiple platform entries')
    } else {
      return platforms[0].marketDetails[market]?.tradingStatus === TradingStatus.DISABLED
    }
  })
}

export const organisationSuspendedSelector = createSelector(
  createAuthorisedUserSelector(),
  createEntityGetterSelector(EntityType.ORGANISATION),
  (authorisedUser, getOrganisation) => {
    const organisation = getOrganisation(authorisedUser.organisationId)
    return organisation ? organisation.status === EntityStatus.DISABLED : false
  }
)

export const userSuspendedSelector = createSelector(createAuthorisedUserSelector(), authorisedUser => {
  return !authorisedUser.canTrade
})
